function provideConfig($provide) {
  // this demonstrates how to register a new tool and add it to the default toolbar
  $provide.decorator('taOptions', [
    '$delegate',
    function (taOptions) {
      // $delegate is the taOptions we are decorating
      // here we override the default toolbars and classes specified in taOptions.
      taOptions.toolbar = [
        ['h1', 'h2', 'h3', 'p', 'pre', 'quote'],
        ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight'],
        ['html', 'insertImage', 'insertLink'],
      ];

      return taOptions; // whatever you return will be the taOptions
    },
  ]);
}

provideConfig.$inject = ['$provide'];

export default provideConfig;
